var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3410_14550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9997 8.33301C73.0122 8.33301 91.6663 26.9872 91.6663 49.9997C91.6663 73.0122 73.0122 91.6663 49.9997 91.6663C26.9872 91.6663 8.33301 73.0122 8.33301 49.9997C8.33301 26.9872 26.9872 8.33301 49.9997 8.33301ZM49.958 41.6663H45.833C44.771 41.6675 43.7495 42.0742 42.9773 42.8032C42.2051 43.5322 41.7404 44.5286 41.6781 45.5888C41.6159 46.649 41.9608 47.6929 42.6424 48.5073C43.3241 49.3217 44.2909 49.8451 45.3455 49.9705L45.833 49.9997V70.7913C45.833 72.958 47.4747 74.7497 49.583 74.9747L50.0413 74.9997H52.083C52.9593 74.9997 53.8133 74.7234 54.5236 74.2102C55.2338 73.6969 55.7642 72.9728 56.0392 72.1407C56.3143 71.3087 56.32 70.4112 56.0555 69.5757C55.7911 68.7403 55.27 68.0094 54.5663 67.4872L54.1663 67.2247V45.8747C54.1663 43.708 52.5247 41.9163 50.4163 41.6913L49.958 41.6663ZM49.9997 29.1663C48.8946 29.1663 47.8348 29.6053 47.0534 30.3867C46.272 31.1681 45.833 32.2279 45.833 33.333C45.833 34.4381 46.272 35.4979 47.0534 36.2793C47.8348 37.0607 48.8946 37.4997 49.9997 37.4997C51.1047 37.4997 52.1646 37.0607 52.946 36.2793C53.7274 35.4979 54.1663 34.4381 54.1663 33.333C54.1663 32.2279 53.7274 31.1681 52.946 30.3867C52.1646 29.6053 51.1047 29.1663 49.9997 29.1663Z",
    fill: "#423E44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3410_14550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationFill);
export default __webpack_public_path__ + "static/media/information-fill.b7e885be90fc00c1d4e52573ea487509.svg";
export { ForwardRef as ReactComponent };